import { render, staticRenderFns } from "./CreateReminderEvent.vue?vue&type=template&id=386ca1b8&"
import script from "./CreateReminderEvent.vue?vue&type=script&lang=js&"
export * from "./CreateReminderEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports